import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["formCard", "formTitle", "formCardBody", "productInput", "kindInput", "startedAtInput", "nextBtn", "amountInput", "saveProductBtn"]

  connect() {
    this.controllerName = `operations--products--bookings--add--product`
    this.account = {}
    this.send_data = { current_user: {}, account: {}, product: {} }
  }

  previousStep() {
    this.stopRefreshing()
    this.getControllerByIdentifier("operations--products--bookings--add--contacts").doContactFormHtml()
    this.getControllerByIdentifier("operations--products--bookings--add--dashboard").current_step = 1
    this.getControllerByIdentifier("operations--products--bookings--add--dashboard").setStep()
  }

  saveProduct() {
    this.saveProductBtnTarget.disabled = true
    this.stopProductRefreshing()

    this.account = this.getControllerByIdentifier("operations--products--bookings--add--dashboard").account

    this.send_data.account.account_id = this.account.id
    this.send_data.account.token = this.account.token
    this.send_data.product.account_id = this.account.id
    this.send_data.product.name = `medbooking`
    this.send_data.product.kind = `practice`
    this.send_data.product.status = `onboard`
    // this.send_data.product.amount = this.getControllerByIdentifier("app--helpers--numbers").fromCurrencyToNumber(this.amountInputTarget.value)
    this.send_data.product.amount = 1
    this.send_data.product.started_at = this.getControllerByIdentifier("app--helpers--date").transformFullDate(this.startedAtInputTarget.value)

    this.send_data.current_user.current_user_id = this.application.current_user.id
    this.send_data.current_user.feature = `medbooking`

    this.requestSave()
  }

  requestSave() {
    var url = "/operations/products/entities/create"
    var method = "POST"

    const init = { method: method, credentials: "same-origin", headers: { "X-CSRF-Token": token, 'Content-Type': 'application/json' }, body: JSON.stringify(this.send_data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.save) {
          var product = response.data.cln
          controller.application.bookings[controller.application.bookings.length] = product
          controller.saveProductBtnTarget.innerText = `Confirmado`
          controller.saveProductBtnTarget.disabled = true
          controller.productConfirmed = true
        } else {
          controller.saveProductBtnTarget.innerText = `Salvar`
          controller.saveProductBtnTarget.disabled = false
          controller.productConfirmed = false
        }
        controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar(response.type, response.message, 2000)
      })
      .catch(error => {
        controller.getControllerByIdentifier("app--helpers--console").console(error)
        controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", controller.getControllerByIdentifier("app--helpers--messages").generalError(), 3000)
      })
  }

  nextStep() {
    this.stopRefreshing()
    this.stopProductRefreshing()
    this.nextBtnTarget.disabled = true

    var controller = this.getControllerByIdentifier("operations--products--bookings--add--dashboard")

    controller.send_product_data.product.name = `medfiling`
    controller.send_product_data.product.name_pretty = `Declaração de Ajuste Anual`
    controller.send_product_data.product.kind = `receivement`
    controller.send_product_data.product.kind_pretty = `Recebimento`
    controller.send_product_data.product.started_at = this.startedAtInputTarget.value
    controller.send_product_data.product.started_at_pretty = this.getControllerByIdentifier("app--helpers--date").transformFullDate(this.startedAtInputTarget.value)
    controller.send_product_data.product.amount = this.getControllerByIdentifier("app--helpers--numbers").fromCurrencyToNumber(this.amountInputTarget.value)
    controller.send_product_data.product.kind_pretty = `Recebimento`
    controller.send_product_data.product.status = `going`

    this.getControllerByIdentifier("operations--products--bookings--add--user").doUserFormHtml()

  }

  doProductFormHtml() {
    var html = this.stopRefreshing()

    var html = `<div class="col-6 mx-auto">
                  <div class="card" style="width:100%;display:relative;" data-${this.controllerName}-target="formCard" data-action="resize@window->${this.controllerName}#layout">
                    <div class="card-header d-flex align-items-center card-header-table-list f-065">
                      <h6 class="card-title display-4" style="padding:1rem;font-size:110%;margin-bottom:0px;" data-${this.controllerName}-target="formTitle">Criando ou Editando Médico</h6>
                    </div>
                    <div class="card-body py-0" style="overflow:auto;" data-${this.controllerName}-target="formCardBody">
                      <div class="row my-2">
                        <div class="col-4">
                          <div class="form-group form-valid-group">
                            <div class="floating-label floating-label-sm">
                              <label for="productForm">Produto</label>
                              <input aria-describedby="productFormHelp" class="form-control form-valid-control" data-${this.controllerName}-target="productInput" placeholder="Produto" type="text" required>
                            </div>
                          </div>
                        </div>
                        <div class="col-4">
                          <div class="form-group form-valid-group">
                            <div class="floating-label floating-label-sm">
                              <label for="kindForm">Tipo</label>
                              <input aria-describedby="kindFormHelp" class="form-control form-valid-control" data-${this.controllerName}-target="kindInput" placeholder="Nome Médico" type="text" required>
                            </div>
                          </div>
                        </div>
                        <div class="col-4">
                          <div class="form-group form-valid-group">
                            <div class="floating-label floating-label-sm">
                              <label for="startedAtForm">Início Em</label>
                              <input aria-describedby="startedAtFormHelp" class="form-control form-valid-control" data-${this.controllerName}-target="startedAtInput" placeholder="Início Em" type="text" required>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      <div class="row my-2 d-none">
                        <div class="col-6">
                          <div class="form-group form-valid-group">
                            <div class="floating-label floating-label-sm">
                              <label for="amountForm">Valor</label>
                              <input aria-describedby="amountFormHelp" class="form-control form-valid-control" data-${this.controllerName}-target="amountInput" data-action="blur->${this.controllerName}#currencyMask keypress->${this.controllerName}#currencyMask keyup->${this.controllerName}#currencyMask" placeholder="Nome Médico" type="text" required>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-2 mb-4">
                        <div class="col-12 px-1 text-right">
                          <button type="button" class="btn btn-primary btn-sm py-2 f-065" data-action="click->${this.controllerName}#saveProduct" data-${this.controllerName}-target="saveProductBtn">Salvar</button>
                        </div>
                      </div>                
                    </div>
                    <div class="card-footer border-top text-right py-1">
                      <button type="button" class="btn btn-primary btn-sm py-2 f-065" data-action="click->${this.controllerName}#nextStep operations--products--bookings--add--dashboard#changeStep" data-next="3" data-${this.controllerName}-target="nextBtn">Próximo</button>
                    </div>
                  </div>
                </div>`

    var controller = this
    // `<button type="button" class="btn btn-secondary btn-sm py-2 f-065" data-dismiss="modal" data-action="click->${this.controllerName}#previousStep">Voltar</button>`
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier("operations--products--bookings--add--dashboard").formTarget.innerHTML = html)
    }).then(() => {
      controller.refreshSaveBtn()
      controller.getControllerByIdentifier("app--helpers--pickdate").pick($(this.startedAtInputTarget), { max: true, months: true, years: 60 })
      controller.formCardTarget.style.height = ($(window).height() * 0.4) + "px"
      controller.productInputTarget.value = `Livro-Caixa`
      controller.kindInputTarget.value = `Consultório`
      controller.amountInputTarget.value = controller.getControllerByIdentifier("app--helpers--numbers").currencyMask(0)
      controller.productInputTarget.disabled = true
      controller.kindInputTarget.disabled = true

      var product_data = controller.getControllerByIdentifier("operations--products--bookings--add--dashboard").send_product_data
      if (product_data.product.amount != undefined) { controller.amountInputTarget.value = controller.getControllerByIdentifier("app--helpers--numbers").currencyMask(product_data.product.amount) }
      if (product_data.product.started_at != undefined) { controller.startedAtInputTarget.value = product_data.product.started_at }

      controller.getControllerByIdentifier("app--helpers--forms").floatingLabel()
    })
  }

  currencyMask(ev) {
    this.getControllerByIdentifier("app--helpers--numbers").changeNumberToCurrency(ev)
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  layout() {
    var targets = ["mainCard"]
    var identifier = ""
    // this.getControllerByIdentifier("app--helpers--layout").resizeMainCard(targets, identifier)
  }

  refreshSaveBtn() {
    var controller = this
    this.refreshProductTimer = setInterval(function () {
      var len = 0

      if (controller.startedAtInputTarget.value == ``) {
        len += 1
      }

      // if (controller.amountInputTarget.value == `R$ 0,00`) {
      //   len += 1
      // }

      if (len == 0) {
        controller.saveProductBtnTarget.disabled = false
      } else {
        controller.saveProductBtnTarget.disabled = true
      }
    }, 200);

    this.refreshTimer = setInterval(function () {
      var len = 0

      if (!controller.productConfirmed) {
        len += 1
      }

      if (len == 0) {
        controller.nextBtnTarget.disabled = false
      } else {
        controller.nextBtnTarget.disabled = true
      }
    }, 200);
  }

  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }

  stopProductRefreshing() {
    if (this.refreshProductTimer) {
      clearInterval(this.refreshProductTimer)
    }
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
